import * as React from "react";
import { connect } from "react-redux";
import { IDeprecatedUIState } from "../../../redux/modules/ui/reducer";
import { IRouterState } from "../../../redux/modules/router/reducer";
import { IGcpAppDispatchProp } from "../../../redux/store";
import { userClicksOverlaySwitchButton } from "./scenarios";
import MapViewSwitchButton from "../MapViewSwitchButton";
import useCurrentGcpRequestStore from "../../../react/ModeCurrentGCPRequest/currentGCPRequestStore";
import { getAnyScanState, getPrescanState } from "../../../redux/rootReducer";

interface IProps extends IGcpAppDispatchProp {
  uiState: IDeprecatedUIState;
  routerState: IRouterState;
  hasElevationMap: boolean;
}

const OverlaySwitchButton: React.FunctionComponent<IProps> = ({
  dispatch,
  uiState,
  routerState,
  hasElevationMap,
}: IProps) => {
  const scan = useCurrentGcpRequestStore(({ GCPRequest }) => GCPRequest?.scan);
  const canShow =
    ((routerState.data && !!routerState.data.scanDate) || scan) &&
    hasElevationMap;

  return canShow ? (
    <MapViewSwitchButton
      className="elevation-switch-button"
      onClick={() => {
        dispatch(userClicksOverlaySwitchButton());
      }}
      imgSrc={
        uiState.elevationMapIsVisible ? "map-ground.png" : "map-elevation.png"
      }
    />
  ) : null;
};

export default connect((state: any) => ({
  uiState: state.deprecatedUi,
  routerState: state.router,
  // Satellite maidens have no DEM, so there is no elevation map to switch to
  hasElevationMap: Boolean(
    getPrescanState(state).data?.elevationMapTilesPath ||
      getAnyScanState(state).data?.elevationMapTilesPath,
  ),
}))(OverlaySwitchButton);
